import triggerEvent, { MailshotReSubscribeEvent } from '../analytics/ga/events';
import { GAEventName } from '../analytics/ga/events';
import { fadeOut } from '../animations/fade';
import { getFormInfo } from '../forms/types';
import { EmailTypePropertyAlert } from './event-unsubscribed';

type ActivateResponse = {
    success: boolean;
    message: string;
    errors?: {
        form: string;
    };
}

export function initActivateAlertsCTA( cta: HTMLElement ): void {
    if ( cta.dataset.initialised ) {
        return;
    }

    cta.dataset.initialised = 'true';

    const form = cta.querySelector( 'form' ) as HTMLFormElement;
    const btn = cta.querySelector( 'button' ) as HTMLButtonElement;
    const txt = cta.querySelector( 'p' ) as HTMLParagraphElement;

    const formInfo = getFormInfo( form );

    async function removeCTA(): Promise<void> {
        await fadeOut( cta );
        cta.remove();
    }

    form.addEventListener( 'submit', async ( event: SubmitEvent ) => {
        event.preventDefault();

        if ( btn.disabled ) {
            return;
        }

        btn.disabled = true;

        form.querySelectorAll( '.activateemailscta__error' ).forEach( ( element: HTMLElement ) => element.remove() );

        const response = await window.http( new URL( window.location.origin + form.getAttribute( 'action' ) ), {
            method: form.method,
        } );

        if ( !response.ok ) {
            btn.disabled = false;
            throw new Error( 'failed to make activate alerts request' );
        }

        const body = await response.json() as ActivateResponse;

        if ( !body.success && body.errors && body.errors.form ) {
            btn.disabled = false;
            form.insertAdjacentHTML(
                'afterbegin',
                `<p class="activateemailscta__error">${body.errors.form}</p>`,
            );
            return;
        }

        if ( body.success ) {
            triggerEvent<MailshotReSubscribeEvent>( GAEventName.MailshotReSubscribe, {
                'email_types': EmailTypePropertyAlert,
                'form_location': formInfo.location,
                'form_type': formInfo.name,
            } );
        }

        if ( body.success && !body.message ) {
            removeCTA();
            return;
        }

        cta.classList.add( 'activateemailscta--successful' );

        txt.innerHTML = body.message;

        form.remove();

        window.setTimeout( removeCTA, 5000 );
    } );
}
